import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

export type BuildingDenialDisposition =
    | 'ordinary'
    | 'access-lost'
    | 'verification-unavailable'
    | 'superseded';

export interface BuildingRequestScope {
    readonly ended$: Observable<void>;
    resolveDeniedRequest$(): Observable<BuildingDenialDisposition>;
}

interface BuildingAccessOwner extends BuildingRequestScope {
    readonly buildingId: string;
    isCurrent(): boolean;
}

/** Connects root HTTP handling to the committed route owner without owning permissions. */
@Injectable({ providedIn: 'root' })
export class BuildingAccessRecovery {
    private owner: BuildingAccessOwner | null = null;

    public bind(owner: BuildingAccessOwner): () => void {
        this.owner = owner;
        return () => {
            if (this.owner === owner) this.owner = null;
        };
    }

    public captureBuildingRequest(
        buildingId: string
    ): BuildingRequestScope | null {
        const owner = this.owner;
        return owner?.buildingId === buildingId && owner.isCurrent()
            ? owner
            : null;
    }
}
